import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, CircularProgress } from "@mui/material";
import { collection, getDocs, query, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { db } from "../../firebase";
import { BirthdayCard } from "./BirthdayCard";

const abel = { fontFamily: "Abel" };
const GOLD = "#ffc000";
const PRIMARY = "#000c66";

const field = (props) => ({
  fullWidth: true,
  color: "secondary",
  margin: "dense",
  inputProps: { style: abel },
  InputLabelProps: { style: abel },
  ...props,
});

export const BirthdayLookup = () => {
  const navigate = useNavigate();
  const [surname, setSurname] = useState("");
  const [last4, setLast4] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [matches, setMatches] = useState([]);
  const [selected, setSelected] = useState(null);
  const [unapproved, setUnapproved] = useState(null);

  const validate = () => {
    const errs = {};
    if (!surname.trim()) errs.surname = "Required";
    if (!/^\d{4}$/.test(last4.trim())) errs.last4 = "Enter exactly 4 digits";
    return errs;
  };

  const reset = () => {
    setNotFound(false);
    setMatches([]);
    setSelected(null);
    setUnapproved(null);
  };

  const resolveMember = (member) => {
    if (member.status === "approved") {
      setSelected(member);
    } else {
      setUnapproved(member);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length) return;

    setLoading(true);
    reset();
    try {
      const lastNameLower = surname.trim().toLowerCase();
      const q = query(
        collection(db, "members"),
        where("lastNameLower", "==", lastNameLower),
      );
      const snap = await getDocs(q);
      const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      const found = all.filter(
        (m) => (m.phone || "").replace(/\D/g, "").slice(-4) === last4.trim(),
      );

      if (!found.length) {
        setNotFound(true);
        toast(
          "We couldn't find a matching membership record. Taking you to the registration page...",
          { type: "error" },
        );
        setTimeout(() => navigate("/join"), 3000);
      } else if (found.length === 1) {
        resolveMember(found[0]);
      } else {
        setMatches(found);
      }
    } catch (err) {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchAgain = () => {
    reset();
    setSurname("");
    setLast4("");
    setErrors({});
  };

  return (
    <section style={{ background: "#fff", padding: "56px 16px 80px" }}>
      <div style={{ maxWidth: 480, margin: "0 auto" }}>
        {selected ? (
          <div style={{ textAlign: "center" }}>
            <BirthdayCard
              name={selected.name}
              imgSrc={selected.imgSrc}
              dob={selected.dob}
            />
            {!selected.dob && (
              <p
                style={{ ...abel, color: PRIMARY, marginTop: 16, fontSize: 15 }}
              >
                We don't have your birth date on record yet — please contact
                the church office to have it added.
              </p>
            )}
            <Button
              onClick={handleSearchAgain}
              variant="outlined"
              style={{
                ...abel,
                marginTop: 24,
                borderColor: PRIMARY,
                color: PRIMARY,
              }}
            >
              Search Again
            </Button>
          </div>
        ) : unapproved ? (
          <div style={{ textAlign: "center" }}>
            <p style={{ ...abel, color: "#9a6b00", fontSize: 15 }}>
              Hi {unapproved.name}, your membership hasn't been approved yet,
              so we can't show your birthday card. Please contact a member of
              the media team to get your membership approved.
            </p>
            <Button
              onClick={handleSearchAgain}
              variant="outlined"
              style={{
                ...abel,
                marginTop: 16,
                borderColor: PRIMARY,
                color: PRIMARY,
              }}
            >
              Search Again
            </Button>
          </div>
        ) : matches.length > 1 ? (
          <div>
            <p style={{ ...abel, color: PRIMARY, marginBottom: 16 }}>
              We found a few members matching that name and number. Which one
              is you?
            </p>
            {matches.map((m) => (
              <button
                key={m.id}
                onClick={() => resolveMember(m)}
                style={{
                  ...abel,
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  padding: "12px 16px",
                  marginBottom: 8,
                  border: `1px solid ${PRIMARY}33`,
                  borderRadius: 8,
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: 16,
                  color: PRIMARY,
                }}
              >
                {m.name}
              </button>
            ))}
            <Button
              onClick={handleSearchAgain}
              style={{ ...abel, marginTop: 8, color: PRIMARY }}
            >
              Back
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              {...field({
                label: "Surname",
                value: surname,
                onChange: (e) => {
                  setSurname(e.target.value);
                  setErrors((p) => ({ ...p, surname: "" }));
                },
                error: !!errors.surname,
                helperText: errors.surname,
              })}
            />
            <TextField
              {...field({
                label: "Last 4 digits of phone number",
                value: last4,
                onChange: (e) => {
                  setLast4(e.target.value.replace(/\D/g, "").slice(0, 4));
                  setErrors((p) => ({ ...p, last4: "" }));
                },
                error: !!errors.last4,
                helperText: errors.last4,
                inputProps: { style: abel, maxLength: 4, inputMode: "numeric" },
              })}
            />

            {notFound && (
              <p style={{ ...abel, color: "#c62828", marginTop: 12 }}>
                We couldn't find a matching record — taking you to the
                registration page to become a member.
              </p>
            )}

            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              fullWidth
              style={{
                ...abel,
                background: PRIMARY,
                color: GOLD,
                marginTop: 20,
                padding: "10px 0",
                fontSize: 16,
              }}
            >
              {loading ? (
                <CircularProgress size={22} style={{ color: GOLD }} />
              ) : (
                "Find My Birthday Card"
              )}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
};
